/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import Slug from '../../../components/slug/slug';
import Video from 'react-jw-player';
import GoogleIMAGenerator from '../../../components/video_module/utils/video_module_ads.js'
import Card from '../../../components/card/card';
import AllFeed from '../../../components/all_feed/all_feed';
import Ad from '../../../components/ad/ad';
// eslint-disable-next-line react/prefer-stateless-function
class VideoPage extends Component {

  constructor() {
    super();
    this.renderVideoCard = this.renderVideoCard.bind(this);
  }

  renderVideoCard (videoData) {
    return {
        link:  `/video/${videoData.slug}/${videoData.mediaid}`,
        title: videoData.title,
        excerpt: videoData.description,
        featured_image: {
          source: videoData.image
        }
      }
    // need to debug which data is getting passed, this was the old : return <Card
    //   key={videoData.mediaid}
    //   className={'all-feed'}
    //   env={this.props.config.env}
    //   hasExcerpt={true}
    //   metadata={}
    // />;
  }

  render() {
    if (this.props.status === 404 || this.props.status === 500) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.videoPage.isLoading) {
      return (
        <section className="video-page">
          <article className="video-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
    const adData = get(this.props, 'videoPage.ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );
    return (
      <section className={`tag-page`}>
        <section className="page-title">
          <Slug
            slugName={`${get(this.props, 'jwVideo.data.title')}`}
            className="category-page"
          />
          <p>{`${get(this.props, 'jwVideo.data.playlist[0].description')}`} Published <date>{`${get(this.props, 'jwVideo.data.playlist[0].formattedDate')}`}</date>. Duration is <time>{`${get(this.props, 'jwVideo.data.playlist[0].formattedDuration')}`}</time>.</p>
          <Video
            playerId={get(this.props, 'jwVideo.data.playlist[0].mediaid')}
            playerScript={`//content.jwplatform.com/libraries/76APbejE.js`}
            playlist={`//content.jwplatform.com/feeds/${get(this.props, 'jwVideo.data.playlist[0].mediaid')}.json`}
            generatePrerollUrl={function generatePreRoll(video) {
              return new GoogleIMAGenerator(video.title).adTag;
            }}
            playInView={true}
            playInViewPercentage={10}
          />
        </section>

        <Ad
          {...combinedAdModel}
          noLazyLoad={true}
          pos="atf"
          name="flexiblebillboard_1"
        />

        <AllFeed
          adModel={combinedAdModel}
          titleOverride="Related Videos"
          stories={get(this.props, 'jwNewestVideo.data.playlist', []).map(this.renderVideoCard)}
        />

        <Ad
          {...combinedAdModel}
          noLazyLoad={true}
          pos="atf"
          name="flexiblebillboard_2"
        />
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    videoPage: get(state, 'videoPage', {error: true}),
    jwVideo: get(state, 'jwVideo'),
    jwRelatedVideo: get(state, 'jwRelatedVideo'),
    jwNewestVideo: get(state, 'jwNewestVideo')
  };
}

VideoPage.propTypes = {
  config: PropTypes.shape(),
  status: PropTypes.number,
  videoPage: PropTypes.shape(),
  jwVideo: PropTypes.shape(),
  jwRelatedVideo: PropTypes.shape(),
  jwNewestVideo: PropTypes.shape()
};

export default connect(mapStateToProps)(VideoPage);



// WEBPACK FOOTER //
// ./src/views/containers/pages/video_page/video_page.js